import createReactComponent from '../createReactComponent';
export default createReactComponent('arrow-left-tail', 'IconArrowLeftTail', [
  ['path', { d: 'M18 12h-15', key: 'svg-0' }],
  ['path', { d: 'M6 9l-3 3l3 3', key: 'svg-1' }],
  ['path', { d: 'M21 9l-3 3l3 3', key: 'svg-2' }],
]);
